import { Outlet, useLocation } from "react-router";

import { BookToggle } from "@/book/book-toggle";
import { ChatColumn } from "@/chat/chat-column";
import { CreateDraftButton } from "@/drafts/create-draft-button";

import { AppNav } from "./app-nav";
import { QwibSearch } from "./qwib-search";

export const QwibLayout = () => {
  const { pathname } = useLocation();
  const isInboxRoute = pathname === "/inbox" || pathname.startsWith("/inbox/");
  const isDraftsRoute = pathname === "/drafts" || pathname.startsWith("/drafts/");
  const routeOwnsChatLayout = isInboxRoute || isDraftsRoute;

  return (
    <>
      <AppNav
        center={
          <>
            <QwibSearch section={isInboxRoute ? "inbox" : isDraftsRoute ? "drafts" : "standalone"} />
          </>
        }
      >
        <BookToggle />
        <CreateDraftButton />
      </AppNav>
      <main className="flex-auto overflow-hidden">
        {routeOwnsChatLayout ? (
          <Outlet />
        ) : (
          <>
            <Outlet />
            <ChatColumn />
          </>
        )}
      </main>
    </>
  );
};
